<template>
	<form @submit.prevent="createPackage()">
		<h2 v-if="!leadPackage" class="mb-5 text-dark">Edit Package</h2>
		<div class="row">
			<div :class="leadPackage ? 'col-sm-12' : 'col-sm-6'">
				<div class="row">
					<h4
						v-if="!leadPackage"
						class="col-md-12 text-dark custom-rounded-15 shadow-md mt-4 py-3"
					>
						Package Information
					</h4>
					<div class="form-group col-sm-6 mb-5">
						<BaseInput
							name="packageName"
							label="Package Name"
							type="text"
							v-model="packageEditState.state.data.name"
							class="form-control form-control-lg dashInput"
							rules="required|min:5"
							@valError="inputError"
							@valSuccess="inputSuccess"
						/>
					</div>
					<div v-if="!leadPackage" class="form-group col-sm-6 mb-5">
						<BaseMultiSelect
							@update:value="setCountry"
							:options="multiSelectState.countriesSelect"
							rules="required"
							:defaultData="packageEditState.state.data.country.id"
							name="Country"
							@valError="inputError"
							@valSuccess="inputSuccess"
						/>
					</div>
					<h5
						class="col-md-12 text-dark custom-rounded-15 shadow-md mt-4 py-3 d-flex justify-content-between align-items-center"
					>
						Cities
						<button
							type="button"
							@click="addComponent"
							class="btn btn-danger btn-sm"
						>
							Add Stay
						</button>
					</h5>
					<div
						v-for="(count, index) in componentCount.count"
						:key="`${count}-stay`"
						class="col-md-6"
					>
						<CityStay
							:id="count"
							:nameIndex="index"
							:country="packageEditState.state.data.country.name"
							:cityObj="packageEditState.state.data?.cities[index]?.city"
							:stayCount="
								packageEditState.state.data?.cities[index]?.stayNights
							"
							@removeComponent="removeComponent"
							@updateData="updateData"
							@removeId="removeCity"
						/>
					</div>

					<h5
						v-if="!leadPackage"
						class="col-md-12 text-dark custom-rounded-15 shadow-md mt-4 py-3"
					>
						Tags
					</h5>
					<div v-if="!leadPackage" class="form-group col-sm-12 mb-5">
						<!-- <label for="tags" class="form-label">Tags</label> -->
						<BaseMultiSelect
							@update:value="setTags"
							:options="multiSelectState.tagsSelect"
							rules="required"
							:defaultData="multiSelectState.selectedTags"
							mode="tags"
							@valError="inputError"
							@valSuccess="inputSuccess"
						/>
					</div>

					<h5
						v-if="!leadPackage"
						class="col-md-12 text-dark custom-rounded-15 shadow-md mt-4 py-3"
					>
						Overview
					</h5>
					<div v-if="!leadPackage" class="form-group col-sm-12 mb-5">
						<textarea
							class="form-control form-control-lg"
							v-model="packageEditState.state.data.overview"
						></textarea>
					</div>

					<h5 class="col-md-12 text-dark custom-rounded-15 shadow-md mt-4 py-3">
						Meal Type
					</h5>
					<div class="form-group col-sm-12 mb-5">
						<div
							v-for="(meal, index) in radioCheckData.mealType"
							:key="`${index}-meal`"
							class="form-check form-check-inline"
						>
							<input
								class="form-check-input"
								type="radio"
								name="meal"
								:id="`mealRadio${index}`"
								:value="meal"
								v-model="packageEditState.state.data.meal"
							/>
							<label
								class="form-check-label text-dark"
								for="mealRadio${index}"
								>{{ meal }}</label
							>
						</div>
					</div>

					<h5 class="col-md-12 text-dark custom-rounded-15 shadow-md mt-4 py-3">
						Other
					</h5>
					<div class="form-group col-sm-12 mb-5">
						<div
							v-for="(other, index) in radioCheckData.inclusion"
							:key="`${index}-other`"
							class="form-check form-check-inline"
						>
							<input
								class="form-check-input"
								type="checkbox"
								:id="`Checkbox${other}`"
								:value="other"
								v-model="packageEditState.state.data.other"
							/>
							<label
								class="form-check-label text-dark"
								for="`Checkbox${other}`"
								>{{ other }}</label
							>
						</div>
					</div>

					<h5
						v-if="!packageEditState.state.data.itinerary && !leadPackage"
						class="col-md-12 text-dark custom-rounded-15 shadow-md mt-4 py-3"
					>
						Itinerary
					</h5>
					<div
						v-if="!packageEditState.state.data.itinerary && !leadPackage"
						class="form-group col-sm-6 mb-5"
					>
						<input
							class="form-check-input"
							v-model="editData.createItinerary"
							type="checkbox"
							value=""
							id="flexCheckIndeterminate"
						/>
						<label
							class="form-check-label mx-2 text-dark"
							for="flexCheckIndeterminate"
						>
							Do You Want to Create Itinerary?
						</label>
					</div>
					<div
						v-if="packageEditState.state.data.itinerary && !leadPackage"
						class="form-group col-sm-6 mb-5"
					>
						<input
							class="form-check-input"
							v-model="editData.editItinerary"
							type="checkbox"
							value=""
							id="flexCheckIndeterminate"
						/>
						<label
							class="form-check-label mx-2 text-dark"
							for="flexCheckIndeterminate"
						>
							Do You Want to Edit Itinerary?
						</label>
					</div>

					<!-- <div v-if="!leadPackage" class="col-sm-12">
						<div
							v-if="packageEditState.state.data.images.length"
							class="col-sm-12"
						>
							<h4>Remove package images</h4>
						</div>
						<div
							v-if="packageEditState.state.data.images.length"
							class="row mx-auto py-4"
						>
							<div
								v-for="image in packageEditState.state.data.images"
								:key="image"
								class="col-sm-2 m-2 position-relative shadow-md"
							>
								<img class="package-img" :src="`${dataImage.url}${image}`" />
								<span
									@click="remove(image)"
									class="position-absolute top-100 start-75 badge rounded-pill bg-danger cursor-pointer"
									><i class="bi bi-x"></i
								></span>
							</div>
						</div>
					</div> -->

					<div v-if="!leadPackage" class="col-sm-12 mt-5">
						<div class="form-check form-switch">
							<input
								class="form-check-input"
								v-model="image.enabled"
								type="checkbox"
								id="imageCheck"
							/>
							<label class="form-check-label text-dark" for="imageCheck"
								>Upload package image</label
							>
						</div>
					</div>

					<div v-if="image.enabled" class="col-sm-12">
						<BaseImageUpload urlParam="packages" @images-data="setImage" />
					</div>

					<h5 class="col-md-12 text-dark custom-rounded-15 shadow-md mt-4 py-3">
						Package Cost Inclusions
					</h5>
					<div class="form-group col-sm-12 mb-5">
						<BaseEditor
							:defaultData="packageEditState.state.data.inclusions"
							@updateData="setInclusion"
							:required="true"
						/>
					</div>

					<h5 class="col-md-12 text-dark custom-rounded-15 shadow-md mt-4 py-3">
						Package Cost Exclusion
					</h5>
					<div class="form-group col-sm-12 mb-5">
						<BaseEditor
							:defaultData="packageEditState.state.data.exclusions"
							@updateData="setExclusion"
							:required="true"
						/>
					</div>

					<!-- <h5
						v-if="!leadPackage"
						class="col-md-12 text-dark custom-rounded-15 shadow-md mt-4 py-3"
					>
						Package Prices
					</h5>
					<div v-if="!leadPackage" class="form-group col-sm-6 mb-5">
						<BaseInput
							name="Season Price"
							label="Season Price"
							type="number"
							:min="2000"
							v-model="packageEditState.state.data.seasonPrice"
							class="form-control form-control-lg dashInput"
							rules="required"
							@valError="inputError"
							@valSuccess="inputSuccess"
						/>
					</div>
					<div v-if="!leadPackage" class="form-group col-sm-6 mb-5">
						<BaseInput
							name="Off Season Price"
							label="Off Season Price"
							type="number"
							:min="2000"
							v-model="packageEditState.state.data.offSeasonPrice"
							class="form-control form-control-lg dashInput"
							rules="required"
							@valError="inputError"
							@valSuccess="inputSuccess"
						/>
					</div> -->

					<div v-if="!leadPackage" class="col-sm-12">
						<div class="form-check form-switch">
							<input
								class="form-check-input"
								v-model="packageEditState.state.data.seasonDatesBool"
								type="checkbox"
								id="imageCheck"
							/>
							<label class="form-check-label text-dark" for="imageCheck"
								>Add Season Dates</label
							>
						</div>
					</div>
					<div
						v-if="packageEditState.state.data.seasonDatesBool"
						class="col-sm-12 pt-4"
					>
						<div class="row">
							<h3>High Season</h3>
						</div>
						<div class="row">
							<div class="form-group col-sm-6 mb-5">
								<BaseInput
									name="DD/MM"
									label="Season Start"
									type="text"
									v-model="
										packageEditState.state.data.seasonDates.seasonOne.startDate
									"
									pattern="[0-9][0-9]\/[0-1][0-9]$"
									class="form-control form-control-lg dashInput"
									rules="required"
									@valError="inputError"
									@valSuccess="inputSuccess"
								/>
							</div>
							<div class="form-group col-sm-6 mb-5">
								<BaseInput
									name="DD/MM"
									label="Season end"
									type="text"
									v-model="
										packageEditState.state.data.seasonDates.seasonOne.endDate
									"
									pattern="[0-9][0-9]\/[0-1][0-9]$"
									class="form-control form-control-lg dashInput"
									rules="required"
									@valError="inputError"
									@valSuccess="inputSuccess"
								/>
							</div>
						</div>

						<div class="row">
							<h3>Mid Season</h3>
						</div>
						<div class="row">
							<div class="form-group col-sm-6 mb-5">
								<BaseInput
									name="DD/MM"
									label="Season Start"
									type="text"
									v-model="
										packageEditState.state.data.seasonDates.seasonTwo.startDate
									"
									pattern="[0-9][0-9]\/[0-1][0-9]$"
									class="form-control form-control-lg dashInput"
									rules="required"
									@valError="inputError"
									@valSuccess="inputSuccess"
								/>
							</div>
							<div class="form-group col-sm-6 mb-5">
								<BaseInput
									name="DD/MM"
									label="Season end"
									type="text"
									v-model="
										packageEditState.state.data.seasonDates.seasonTwo.endDate
									"
									class="form-control form-control-lg dashInput"
									pattern="[0-9][0-9]\/[0-1][0-9]$"
									rules="required"
									@valError="inputError"
									@valSuccess="inputSuccess"
								/>
							</div>
						</div>

						<div class="row">
							<h3>Low Season</h3>
						</div>
						<div class="row">
							<div class="form-group col-sm-6 mb-5">
								<BaseInput
									name="DD/MM"
									label="Season Start"
									type="text"
									v-model="
										packageEditState.state.data.seasonDates.seasonThree
											.startDate
									"
									class="form-control form-control-lg dashInput"
									pattern="[0-9][0-9]\/[0-1][0-9]$"
									rules="required"
									@valError="inputError"
									@valSuccess="inputSuccess"
								/>
							</div>
							<div class="form-group col-sm-6 mb-5">
								<BaseInput
									name="DD/MM"
									label="Season end"
									type="text"
									v-model="
										packageEditState.state.data.seasonDates.seasonThree.endDate
									"
									pattern="[0-9][0-9]\/[0-1][0-9]$"
									class="form-control form-control-lg dashInput"
									rules="required"
									@valError="inputError"
									@valSuccess="inputSuccess"
								/>
							</div>
						</div>
					</div>

					<!-- <div v-if="packageEditState.state.data?.includedDeal" class="row">
						<div class="row my-5">
								<h4>Luxury Package</h4>
								<div class="packageWrapper">
									<PackageDeal
										v-for="(city, index) in packageEditState.state.data?.cities"
										:key="`${city.city.name}-${index}`"
										:id="index"
										dealName="luxury"
										:city="city.city"
										:defaultData="
											packageEditState.state.data.luxuryPackage.length ? packageEditState.state.data.luxuryPackage[index] : ''
										"
										@updateData="setLuxuryPackage"
										@removeData="removePackage"
									/>
								</div>
							</div>
							<div class="row my-5">
								<h4>Gold Package</h4>
								<PackageDeal
									v-for="(city, index) in packageEditState.state.data.cities"
									:key="`${city.city.name}-${index}`"
									:id="index"
									dealName="gold"
									:city="city.city"
									:defaultData="packageEditState.state.data?.goldPackage"
									@updateData="setGoldPackage"
									@removeData="removePackage"
								/>
							</div>
							<div class="row my-5">
								<h4>Silver Package</h4>
								<PackageDeal
									v-for="(city, index) in packageEditState.state.data?.cities"
									:key="`${city.city.name}-${index}`"
									:id="index"
									dealName="silver"
									:city="city.city"
									:defaultData="packageEditState.state.data?.silverPackage"
									@updateData="setSilverPackage"
									@removeData="removePackage"
								/>
							</div>
							<div class="row my-5">
								<h4>Platinum Package</h4>
								<PackageDeal
									v-for="(city, index) in data.cities"
									:key="`${city.city.name}-${index}`"
									:id="index"
									dealName="platinum"
									:city="city.city"
									:defaultData="packageEditState.state.data?.platinumPackage"
									@updateData="setPlatinumPackage"
									@removeData="removePackage"
								/>
							</div>

							<div class="row my-5">
								<h4>Bronze Package</h4>
								<PackageDeal
									v-for="(city, index) in packageEditState.state.data.cities"
									:key="`${city.city.name}-${index}`"
									:id="index"
									dealName="bronze"
									:city="city.city"
									:defaultData="packageEditState.state.data?.bronzePackage"
									@updateData="setBronzePackage"
									@removeData="removePackage"
								/>
							</div>
					</div> -->

					<div class="col-sm-12 my-5">
						<div class="form-check form-switch">
							<input
								class="form-check-input"
								v-model="editPackageDeal"
								type="checkbox"
								id="packageDeal"
							/>
							<label class="form-check-label text-dark" for="packageDeal">{{
								packageEditState.state.data?.includedDeal
									? "Edit Package Deals"
									: "Add Package Deals"
							}}</label>
						</div>
					</div>
					<div v-if="editPackageDeal" class="row">
						<div
							v-if="
								packageEditState.state.data?.bronzePackage &&
								packageEditState.state.data?.cities.length
							"
							class="row my-5"
						>
							<h4>Bronze Package</h4>
							<PackageDeal
								v-for="(city, index) in packageEditState.state.data.cities"
								:key="`${city.city.name}-${index}`"
								:id="
									packageEditState.state.data?.bronzePackage.length
										? packageEditState.state.data?.bronzePackage[index]?.id
											? packageEditState.state.data?.bronzePackage[index].id ===
											  index
												? packageEditState.state.data?.bronzePackage[index].id
												: index
											: index
										: index
								"
								dealName="bronze"
								:city="city.city"
								:sightCount="
									packageEditState.state.data?.bronzePackage[index]
										?.staySights &&
									packageEditState.state.data?.bronzePackage[index]?.staySights
										.length
										? packageEditState.state.data?.bronzePackage[index]
												?.staySights.length
										: 0
								"
								:defaultData="
									packageEditState.state.data?.bronzePackage.length
										? packageEditState.state.data?.bronzePackage[index] &&
										  packageEditState.state.data?.bronzePackage[index].id ===
												index
											? packageEditState.state.data?.bronzePackage[index]
											: ''
										: ''
								"
								@updateData="setBronzePackage"
								@removeData="removePackage"
							/>
						</div>
						<div
							v-if="
								packageEditState.state.data?.platinumPackage &&
								packageEditState.state.data?.cities.length
							"
							class="row my-5"
						>
							<h4>Platinum Package</h4>
							<PackageDeal
								v-for="(city, index) in packageEditState.state.data?.cities"
								:key="`${city.city.name}-${index}`"
								:id="
									packageEditState.state.data?.platinumPackage.length
										? packageEditState.state.data?.platinumPackage[index]?.id
											? packageEditState.state.data?.platinumPackage[index]
													.id === index
												? packageEditState.state.data?.platinumPackage[index].id
												: index
											: index
										: index
								"
								dealName="platinum"
								:city="city.city"
								:sightCount="
									packageEditState.state.data?.platinumPackage[index]
										?.staySights &&
									packageEditState.state.data?.platinumPackage[index]
										?.staySights.length
										? packageEditState.state.data?.platinumPackage[index]
												?.staySights.length
										: 0
								"
								:defaultData="
									packageEditState.state.data?.platinumPackage.length
										? packageEditState.state.data?.platinumPackage[index] &&
										  packageEditState.state.data?.platinumPackage[index].id ===
												index
											? packageEditState.state.data?.platinumPackage[index]
											: ''
										: ''
								"
								@updateData="setPlatinumPackage"
								@removeData="removePackage"
							/>
						</div>
						<div
							v-if="
								packageEditState.state.data?.silverPackage &&
								packageEditState.state.data?.cities.length
							"
							class="row my-5"
						>
							<h4>Silver Package</h4>
							<PackageDeal
								v-for="(city, index) in packageEditState.state.data.cities"
								:key="`${city.city.name}-${index}`"
								:id="
									packageEditState.state.data?.silverPackage.length
										? packageEditState.state.data?.silverPackage[index]?.id
											? packageEditState.state.data?.silverPackage[index].id ===
											  index
												? packageEditState.state.data?.silverPackage[index].id
												: index
											: index
										: index
								"
								dealName="silver"
								:city="city.city"
								:sightCount="
									packageEditState.state.data?.silverPackage[index]
										?.staySights &&
									packageEditState.state.data?.silverPackage[index]?.staySights
										.length
										? packageEditState.state.data?.silverPackage[index]
												?.staySights.length
										: 0
								"
								:defaultData="
									packageEditState.state.data?.silverPackage.length
										? packageEditState.state.data?.silverPackage[index] &&
										  packageEditState.state.data?.silverPackage[index].id ===
												index
											? packageEditState.state.data?.silverPackage[index]
											: ''
										: ''
								"
								@updateData="setSilverPackage"
								@removeData="removePackage"
							/>
						</div>
						<div
							v-if="
								packageEditState.state.data?.goldPackage &&
								packageEditState.state.data?.cities.length
							"
							class="row my-5"
						>
							<h4>Gold Package</h4>
							<PackageDeal
								v-for="(city, index) in packageEditState.state.data?.cities"
								:key="`${city.city.name}-${index}`"
								:id="
									packageEditState.state.data?.goldPackage.length
										? packageEditState.state.data?.goldPackage[index]?.id
											? packageEditState.state.data?.goldPackage[index].id ===
											  index
												? packageEditState.state.data?.goldPackage[index].id
												: index
											: index
										: index
								"
								dealName="gold"
								:city="city.city"
								:sightCount="
									packageEditState.state.data?.goldPackage[index]?.staySights &&
									packageEditState.state.data?.goldPackage[index]?.staySights
										.length
										? packageEditState.state.data?.goldPackage[index]
												?.staySights.length
										: 0
								"
								:defaultData="
									packageEditState.state.data?.goldPackage.length
										? packageEditState.state.data?.goldPackage[index] && packageEditState.state.data?.goldPackage[index].id ===
										  index
											? packageEditState.state.data?.goldPackage[index]
											: ''
										: ''
								"
								@updateData="setGoldPackage"
								@removeData="removePackage"
							/>
						</div>
						<div
							v-if="
								packageEditState.state.data?.luxuryPackage &&
								packageEditState.state.data?.cities.length
							"
							class="row my-5"
						>
							<h4>Luxury Package</h4>
							<div class="packageWrapper">
								<PackageDeal
									v-for="(city, index) in packageEditState.state.data?.cities"
									:key="`${city.city.name}-${index}`"
									:id="
										packageEditState.state.data?.luxuryPackage.length
											? packageEditState.state.data?.luxuryPackage[index]?.id
												? packageEditState.state.data?.luxuryPackage[index]
														.id === index
													? packageEditState.state.data?.luxuryPackage[index].id
													: index
												: index
											: index
									"
									dealName="luxury"
									:city="city.city"
									:stay="city.stayNights"
									:sightCount="
										packageEditState.state.data?.luxuryPackage[index]
											?.staySights &&
										packageEditState.state.data?.luxuryPackage[index]
											?.staySights.length
											? packageEditState.state.data?.luxuryPackage[index]
													?.staySights.length
											: 0
									"
									:defaultData="
										packageEditState.state.data?.luxuryPackage.length
											? packageEditState.state.data?.luxuryPackage[index] && packageEditState.state.data?.luxuryPackage[index].id ===
											  index
												? packageEditState.state.data?.luxuryPackage[index]
												: ''
											: ''
									"
									@updateData="setLuxuryPackage"
									@removeData="removePackage"
								/>
							</div>
						</div>
					</div>

					<Itinerary
						v-if="editData.editItinerary || editData.createItinerary"
						:name="editData.editItinerary ? 'Edit' : 'Create'"
						:count="editData.itineraryCount"
						@updateItinerary="updateItinerary"
					/>

					<div v-if="!leadPackage" class="form-group col-sm-12 mt-2">
						<BaseButton
							class="btn btn-primary form-control form-control-lg"
							type="submit"
							label="Save Package"
							:disabled="formState.disable"
							:loading="formState.isLoading"
						/>
					</div>
				</div>
			</div>
			<div v-if="!leadPackage" class="col-sm-4 px-4">
				<h4 class="text-dark fs-4">Global Trip Holidays</h4>
				<p class="text-dark">
					You are changing an existing package data. Proceed with caution this
					action will modify existing package data.
				</p>
			</div>
		</div>
	</form>
</template>
<script>
	import { reactive, ref, inject, watch, onBeforeUnmount } from "vue";
	import { useRouter } from "vue-router";
	import API from "@/config/api";
	import toast from "@/config/toast";
	import BaseInput from "./BaseInput.vue";
	import BaseMultiSelect from "./BaseMultiSelect.vue";
	import BaseButton from "./BaseButton.vue";
	import CityStay from "./CityStay.vue";
	import BaseFileInput from "./BaseFileInput.vue";
	import Itinerary from "./CreateItinerary.vue";
	import BaseEditor from "./BaseEditor.vue";
	import BaseImageUpload from "./BaseImageUpload.vue";
	import PackageDeal from "./PackageDeal.vue";

	import Helper from "@/helpers/dataHelper";
	import FormCheck from "@/helpers/formCheckHelper";

	export default {
		name: "PackageEdit",
		components: {
			BaseInput,
			BaseButton,
			BaseMultiSelect,
			CityStay,
			BaseFileInput,
			Itinerary,
			BaseEditor,
			BaseImageUpload,
			PackageDeal,
		},
		props: {
			leadPackage: { type: Boolean, default: false },
		},

		setup: (props) => {
			// adding a global state

			const store = inject("store");
			const masterStore = inject("masterStore");
			const packageEditState = inject("packageEditState");
			const router = useRouter();

			if (!store.state.auth.isAuth) router.push({ name: "Login" });

			// sorting function for Itinerary array objects
			const dynamicSort = (property) => {
				const sortOrder = 1;

				return (a, b) => {
					// a should come before b in the sorted order
					if (a[property] < b[property]) {
						return -1 * sortOrder;
						// a should come after b in the sorted order
						// eslint-disable-next-line no-else-return
					} else if (a[property] > b[property]) {
						return 1 * sortOrder;
						// a and b are the same
					} else {
						return 0 * sortOrder;
					}
				};
			};

			masterStore.methods.setEditBool(true);
			if (!props.leadPackage) {
				packageEditState.state.data = {
					...masterStore.state.data,
				};
			}
			packageEditState.state.data.itineraryDayWise =
				packageEditState.state.data.itineraryDayWise.sort(dynamicSort("day"));
			if (packageEditState.state.data.includedDeal) {
				const deals = [
					"luxuryPackage",
					"goldPackage",
					"silverPackage",
					"platinumPackage",
					"bronzePackage",
				];

				deals.map((key) => {
					console.log("pack deal before =>", packageEditState.state.data[key]);
					if (packageEditState.state.data[key].length) {
						packageEditState.state.data[key] = [
							...packageEditState.state.data[key].sort(dynamicSort("id")),
						];
					}
					console.log("pack deal after =>", packageEditState.state.data[key]);
				});
			}
			if (!packageEditState.state?.data?.seasonDatesBool) {
				// inserting season dates object
				packageEditState.state.data.seasonDates = {
					seasonOne: { startDate: "", endDate: "" },
					seasonTwo: { startDate: "", endDate: "" },
					seasonThree: { startDate: "", endDate: "" },
				};
			}

			const editData = reactive({
				editItinerary: false,
				createItinerary: false,
				itineraryCount: 0,
			});

			const multiSelectState = reactive({
				countries: [],
				countriesSelect: [],

				states: [],

				tags: [],
				tagsSelect: [],
				selectedTags: [],

				transports: [],
				transportSelect: [],
			});

			const radioCheckData = reactive({
				mealType: [],
				inclusion: [],
			});

			radioCheckData.mealType = Helper.mealType;
			radioCheckData.inclusion = Helper.otherData;

			const formState = reactive({
				isLoading: false,
				disable: false,
			});
			const image = reactive({
				enabled: false,
			});
			const dataImage = reactive({
				url: process.env.VUE_APP_IMAGE_PREFIX,
			});
			const componentCount = reactive({ count: [1] });
			const editPackageDeal = ref(false);

			// setting city data and itinerary count
			if (packageEditState.state.data?.cities.length) {
				const countArray = [];

				for (let i = 0; i < packageEditState.state.data.cities.length; i++) {
					countArray.push(i + 1);
				}

				componentCount.count = [...countArray];
			}

			const setItineraryCount = () => {
				if (!packageEditState.state.data?.cities) return;
				// console.log(packageEditState.state.data.cities);
				const citiesData = [...packageEditState.state.data.cities];
				const nightCount = citiesData.reduce(
					(previousStay, currentStay) => currentStay.stayNights + previousStay,
					0,
				);
				if (
					packageEditState.state.data?.itineraryDayWise &&
					packageEditState.state.data.itineraryDayWise.length
				) {
					editData.itineraryCount =
						packageEditState.state.data.itineraryDayWise.length - 1 || 0;
				}

				if (editData.itineraryCount > nightCount) {
					let removeDays = editData.itineraryCount - nightCount;
					let itineraryData = [...packageEditState.state.data.itineraryDayWise];

					for (let i = 0; i < removeDays; i++) {
						itineraryData.pop();
					}
					packageEditState.state.data.itineraryDayWise = [...itineraryData];
				}

				editData.itineraryCount = nightCount;
				editData.editItinerary = false;
				return true;
			};

			const nullable = [
				"images",
				"overview",
				"cities",
				"inclusions",
				"exclusions",
				"tags",
				"other",
			];

			if (packageEditState.state.data.tags.length) {
				packageEditState.state.data.tags.map((tag) =>
					multiSelectState.selectedTags.push(tag.id),
				);
			}

			const changeFormLoadingState = () =>
				(formState.isLoading = !formState.isLoading);

			// ! Country Functions
			const getCountries = async () => {
				try {
					const response = await Helper.getCountries();
					const countries = response;
					multiSelectState.countries = countries;
					multiSelectState.countriesSelect = countries.map((country) => {
						return { label: country.name, value: country.id };
					});
				} catch (error) {
					console.log(error);
				}
			};

			const getState = async (stateObj = false) => {
				let apiObj = {};
				if (stateObj instanceof Object && stateObj?.name.length < 3) return;
				if (stateObj instanceof Object && stateObj?.name)
					apiObj.name = stateObj.name;

				if (data?.country?.name)
					apiObj.countryName = packageEditState.state.data.country.name;
				try {
					const states = await Helper.getStates(apiObj);
				} catch (error) {}
			};

			// ? setting country
			const setCountry = (dataObj) => {
				if (!dataObj) {
					packageEditState.state.data.country = { id: 0, name: null };
					return;
				}

				// ? finding selected city data
				const country = multiSelectState.countries.filter(
					(country) => country.id === dataObj,
				);
				// ? changing state value without re-render
				packageEditState.state.data.country = {
					id: country[0].id,
					name: country[0].name,
				};
			};

			const getTags = async () => {
				try {
					const response = await API.privateRequest.get("tags");
					const changedTags = response.data.data.map((tag) => ({
						value: tag._id,
						label: tag.name,
					}));
					multiSelectState.tags = response.data.data;
					multiSelectState.tagsSelect = changedTags;
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
				}
			};

			// ? setting selected tags in state
			const setTags = (value) => {
				let selectedID = Object.values(value);

				const selectedTag = multiSelectState.tags.flatMap((tag) => {
					let selected = selectedID.map((id) => {
						if (tag._id === id) {
							let data = { id: tag._id, name: tag.name };
							return data;
						}
					});

					return selected;
				});

				packageEditState.state.data.tags = selectedTag.filter(Boolean);
			};

			getCountries();
			getTags();

			const removeCity = (removeId) => {
				packageEditState.state.data.cities =
					packageEditState.state.data.cities.filter(
						(dataObj) => dataObj.city.id !== removeId,
					);
			};

			const createPackage = async () => {
				changeFormLoadingState();
				formState.disable = true;

				// if (validation.invalid.length) {
				// 	toast.error("Incomplete form", true);
				// 	changeFormLoadingState();
				// 	return;
				// }
				// if (data.itinerary) {
				// 	masterStore.methods.changeData(data);
				// 	masterStore.methods.changeComponent("itinerary");
				// 	return;
				// }
				if (editPackageDeal) packageEditState.state.data.includedDeal = true;
				try {
					await API.privateRequest.patch(
						`packages/${masterStore.state.editId}`,
						packageEditState.state.data,
					);
					toast.success(
						{ message: "Package updated!", position: "topRight" },
						true,
					);
					masterStore.methods.destroy();
					packageEditState.state.editBool = false;
					packageEditState.state.data = {};
					masterStore.methods.changeComponent("table");
					// changeFormLoadingState();
				} catch (err) {
					let message;
					if (err?.response?.status < 500 && err?.response?.status >= 400) {
						message = err.response.data.message;
					} else if (err?.response?.status >= 500) {
						message = "Oops! something went wrong";
					} else {
						message = "App Error";
					}

					toast.error(message, true);
					changeFormLoadingState();
					formState.disable = false;
					// console.log(err) //! console here
				}
			};

			const setInclusion = (payload) => {
				packageEditState.state.data.inclusions = payload;
			};
			const setExclusion = (payload) => {
				packageEditState.state.data.exclusions = payload;
			};

			// event handler for input validation event
			const inputError = (input) => {
				// let check = FormCheck.valError(input, data, nullable);
				// console.log("input error: ::");
				// console.log(check);
				// formState.disable = check;
			};

			const inputSuccess = (input) => {
				// let check = FormCheck.valSuccess(input, data, nullable);
				// console.log("input success: ::");
				// console.log(check);
				// formState.disable = check;
			};

			// ? duplicating City Stay component
			const addComponent = () => {
				componentCount.count = [
					...componentCount.count,
					componentCount.count[componentCount.count.length - 1] + 1,
				];
			};
			const removeComponent = (id) => {
				packageEditState.state.data.cities =
					packageEditState.state.data.cities.filter((city) => city.id !== id);
				const newCount = componentCount.count.filter((count) => count !== id);
				componentCount.count = { ...newCount };
			};

			const updateData = (payload) => {
				try {
					let packageCities = [...packageEditState.state.data.cities];
					let payloadData = { ...payload };

					if (packageCities.length) {
						let found = false;

						let newPackageCities = packageCities.map((city) => {
							let cityObj = { ...city };
							if (city.city.id === payload.city.id) {
								cityObj = { ...payload };
								found = true;
							}

							return cityObj;
						});

						packageEditState.state.data.cities = [...newPackageCities];

						if (!found) {
							packageEditState.state.data.cities = [
								...packageEditState.state.data.cities,
								payload,
							];
						}
					} else {
						packageEditState.state.data.cities = [...packageCities, payload];
					}
					setItineraryCount();
					return true;
				} catch (error) {
					console.log(error);
				}
			};

			const updateItinerary = (itinerary) => {
				packageEditState.state.data.itineraryDayWise = itinerary.map(
					(itinerary) => {
						delete itinerary._id;
						return itinerary;
					},
				);
			};

			const setImage = (images) => {
				if (!images.length) return;
				packageEditState.state.data.images = [
					...packageEditState.state.data.images,
					...images,
				];
				formState.disable = false;
			};

			const remove = async (img) => {
				if (!img) return;
				try {
					let response = await API.privateRequest.delete(
						`files?file=${img.split("/")[img.split("/").length - 1]}`,
					);
					if (response.data.success) {
						packageEditState.state.data.images =
							packageEditState.state.data.images.filter(
								(image) => image !== img,
							);
					}
				} catch (err) {
					console.log("image remove error ->", err);
				}
			};

			const setPackageDealDataObj = (key, payload) => {
				try {
					if (!payload instanceof Object) return;
					if (
						Array.isArray(packageEditState.state.data[key]) &&
						packageEditState.state.data[key].length
					) {
						let foundDeal = false;
						const newPackageDeal = packageEditState.state.data[key].map(
							(packageDeal) => {
								let deal = { ...packageDeal };
								if (deal.id === payload.id) {
									deal = { ...payload };
									foundDeal = true;
								}
								return deal;
							},
						);
						packageEditState.state.data[key] = [...newPackageDeal];
						if (!foundDeal)
							packageEditState.state.data[key] = [
								...newPackageDeal,
								{ ...payload },
							];
						return;
					}
					packageEditState.state.data[key] = [{ ...payload }];
				} catch (error) {
					console.log("error in setPackageDeal");
				} finally {
					packageEditState.state.data.includedDeal = true;
					console.log("Final Deal Data", packageEditState.state.data[key]);
				}
			};

			const setLuxuryPackage = (payload) => {
				setPackageDealDataObj("luxuryPackage", payload);
			};

			const setGoldPackage = (payload) => {
				setPackageDealDataObj("goldPackage", payload);
			};
			const setSilverPackage = (payload) => {
				setPackageDealDataObj("silverPackage", payload);
			};
			const setPlatinumPackage = (payload) => {
				setPackageDealDataObj("platinumPackage", payload);
			};
			const setBronzePackage = (payload) => {
				setPackageDealDataObj("bronzePackage", payload);
			};
			const removePackage = (dataObj) => {
				if (!dataObj.dealName || !dataObj.id) return;
				try {
					if (
						Object.prototype.hasOwnProperty.call(
							packageEditState.state.data,
							dataObj.dealName,
						)
					)
						new Error(
							`Unknown key error:  ${dataObj.dealName} is not defined on data object`,
						);
					const dealData = packageEditState.state.data[
						`${dataObj.dealName}Package`
					].filter((deal) => deal.id !== dataObj.id);
					packageEditState.state.data[`${dataObj.dealName}Package`] = [
						...dealData,
					];
				} catch (error) {
					console.log("error removing package deal");
				}
			};

			onBeforeUnmount(() => {
				packageEditState.state.editBool = false;
				packageEditState.state.data = null;
			});

			return {
				packageEditState,
				masterStore,
				multiSelectState,
				componentCount,
				radioCheckData,
				editData,
				editPackageDeal,
				image,
				dataImage,

				addComponent,
				removeComponent,
				updateData,
				updateItinerary,

				createPackage,

				inputError,
				inputSuccess,

				formState,

				getCountries,
				setCountry,
				setTags,
				removeCity,
				setInclusion,
				setExclusion,
				setImage,
				setLuxuryPackage,
				setGoldPackage,
				setSilverPackage,
				setPlatinumPackage,
				setBronzePackage,

				remove,
				removePackage,
			};
		},
	};
</script>
<style scoped>
	.custom-dark-text custom-rounded-15 shadow-lg mt-4 py-3 {
		padding: 10px 15px 10px 5px;
		background-color: white !important;
		border-radius: 4px;
		cursor: pointer;
		border-bottom: 1px solid #eee !important;
		margin-bottom: 1rem;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.package-img {
		width: 100%;
	}
</style>